import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

import { colors } from "@/theme/tokens/colors";

export const CheckListIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon sx={{ width: "18px", height: "18px" }} {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1458_8478)">
        <path
          d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke={colors.brand.blue}
          strokeWidth="2.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1458_8478">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
